import logo from "../../Assets/b11294fb-c442-4a68-a77a-741a0d048dad-removebg-preview.png"
import founder from "../../Assets/WhatsApp Image 2026-07-30 at 13.53.05.jpeg"

export default {
    logo,
    founder,
}